import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/teams/$id/edit")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
